import * as React from 'react';
import { AvailableForPickupFilter } from './AvailableForPickupFilter';
import { CustomerFilter } from './CustomerFilter';
import { GatedOutFilter } from './GatedOutFilter';
import { HoldsFilter } from './HoldsFilter';
import { LastFreeDayFilter } from './LastFreeDayFilter';
import { MoreFilters } from './MoreFilters';
import { TerminalPickupFilter } from './TerminalPickupFilter';

/**
 * Renders the + Add Filter button and the resulting popover when clicked,
 * as well as the list of active filters
 */
export const Filters: React.FC = () => {
  return (
    <div className="flex space-x-8">
      <TerminalPickupFilter />
      <CustomerFilter />
      <AvailableForPickupFilter />
      <HoldsFilter />
      <LastFreeDayFilter />
      <GatedOutFilter />
      <MoreFilters />
    </div>
  );
};
Filters.displayName = 'TrackAndTrace.Controls.filters.Filters';
